(function e(t,n,r){function s(o,u){if(!n[o]){if(!t[o]){var a=typeof require=="function"&&require;if(!u&&a)return a(o,!0);if(i)return i(o,!0);var f=new Error("Cannot find module '"+o+"'");throw f.code="MODULE_NOT_FOUND",f}var l=n[o]={exports:{}};t[o][0].call(l.exports,function(e){var n=t[o][1][e];return s(n?n:e)},l,l.exports,e,t,n,r)}return n[o].exports}var i=typeof require=="function"&&require;for(var o=0;o<r.length;o++)s(r[o]);return s})({1:[function(require,module,exports){
'use strict';

$(document).ready(function () {
	var custom = false;
	if (sig_type == 7) custom = true;
	$('#usr_prof').change(function () {
		if (demo === true || administrator === false) window.location = '/register';
		var tmp_val = $(this).val();

		$.post('/facility/members/update-electronic-signature', { prof_uid: tmp_val, id: usr_uid }, function (data) {

			if (data.data) {

				$('body').prepend('<div class="pop_up tan"><p style="text-align:left;font-size:125%;"><i id="msgClose" class="icon-cancel-circled" data-icon="i" style="float:right;margin:0 0 0 10px;font-size:26px;max-height:26px;overflow:hidden"></i>Your profession has been updated.</p></div><div class="overlay"></div>');

				$('#msgClose').click(function () {
					location.reload();
				});
			} else {

				$('body').prepend('<div class="pop_up tan"><p style="text-align:left;font-size:125%;"><i id="msgClose" class="icon-cancel-circled" data-icon="i" style="float:right;margin:0 0 0 10px;font-size:26px;max-height:26px;overflow:hidden"></i>An error has occurred, please try again.</p></div><div class="overlay"></div>');

				$('#msgClose').click(function () {
					location.reload();
				});
			}
		}, 'json');
	});

	var sigdiv = $("#signature");
	var sigLg = $('#sigsample_lg');

	if (custom) {
		sigdiv.jSignature();
	}

	$('#clear_sig').click(function () {
		if (custom) sigdiv.jSignature("reset");
	});

	$('#save_sig').click(function () {
		if (custom) {
			var svg_base64 = sigdiv.jSignature('getData', 'svgbase64');
			saveSigData(encodeURIComponent("data:" + svg_base64[0] + "," + svg_base64[1]));
		}
	});

	$('input[type="radio"]').change(function () {
		if (demo === true || administrator === false) window.location = '/register';
		var val = $(this).val();
		if (val == 7) {
			sigdiv.empty();
			sigdiv.jSignature();
			custom = true;
		} else {
			custom = false;
		}
		$.post('/facility/members/update-electronic-signature', { usr_sig_type: $(this).val(), id: usr_uid }, function (data) {
			if (val != 7) $('#sigsample').removeClass().addClass('sig_text_' + val);
			if (val != 7) sigLg.removeClass().addClass('sig_text_' + val);
			if (val != 7) {
				sigdiv.empty();
				sigdiv.append(sigLg);
				sigLg.show();
			}
			if (data.error) {
				popUpMsg('Failed to update electronic signature.');
			}
		}, 'json');
	});
});

function saveSigData(sig_data) {
	if (demo === true || administrator === false) window.location = '/register';
	var input = { usr_sig_type: $('input[type="radio"]:checked').val(), id: usr_uid };
	if (input['usr_sig_type'] == 7) input['usr_sig'] = sig_data;
	$.post('/facility/members/update-electronic-signature', input, function (data) {

		$('body').prepend('<div class="pop_up tan"><p style="text-align:left;font-size:125%;"><i id="msgClose" class="icon-cancel-circled" data-icon="i" style="float:right;margin:0 0 0 10px;font-size:26px;max-height:26px;overflow:hidden"></i>Your signature has been updated.</p></div><div class="overlay"></div>');
		$('#msgClose').click(function () {
			location.reload();
		});

		if (data.error) {
			popUpMsg('Failed to save signature.');
		}
	}, 'json');
}

},{}]},{},[1]);
